import React from 'react';
import { FolderKanban } from 'lucide-react';
import { useProject } from '../../contexts/ProjectContext';

export function ProjectSelector() {
  const { projects, activeProjectId, setActiveProject, loading } = useProject();

  const activeProjects = projects.filter((p) => p.is_active);

  return (
    <div className="flex items-center gap-1.5">
      <FolderKanban className="h-4 w-4 text-zinc-400 dark:text-zinc-500 shrink-0" />
      <select
        value={activeProjectId ?? ''}
        onChange={(e) => setActiveProject(e.target.value || null)}
        disabled={loading}
        className="
          appearance-none bg-transparent text-sm font-medium
          text-zinc-700 dark:text-zinc-300
          border border-zinc-200 dark:border-zinc-700
          rounded-md px-2 py-1 pr-6
          hover:border-zinc-300 dark:hover:border-zinc-600
          focus:outline-none focus:ring-1 focus:ring-blue-500 dark:focus:ring-blue-400
          cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed
          transition-colors
        "
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 6px center',
        }}
      >
        <option value="">All Projects</option>
        {activeProjects.map((project) => (
          <option key={project.id} value={project.id}>
            {project.db_connection_id ? '\u{1F7E2}' : '\u26AA'} {project.display_name}
          </option>
        ))}
      </select>
    </div>
  );
}
